import { Space, Title } from '@mantine/core';
import { useNavigate, useLocation } from 'react-router-dom';
import classes from './NewLca.module.css';
import CategoryType from './CategoryComponent/CategoryType.component';
import VerticalsLca from './VerticalComponent/VerticalsLca.component';
import { useState, useEffect, memo, useContext } from 'react';
// import { authContext } from '../../../context/AuthProvider.component';

const NewLca = () => {
    // const { draftLca } = useContext<any>(authContext);

    const navigate = useNavigate();
    const location = useLocation();
    const [verticalid, setVerticalId] = useState<any>(() => {
        const storedId = sessionStorage.getItem('selectedVerticalId');
        return storedId ? JSON.parse(storedId) : true;
    });

    const handleVerticalSelect = (data: any) => {
        setVerticalId(data);
        sessionStorage.setItem('selectedVerticalId', JSON.stringify(data));
        navigate(`/newlca/sub-category`);
    };

    // useEffect(() => {
    //     if (draftLca != null) {
    //         if (location.pathname.endsWith('/newlca/sub-category')) {
    //             console.log(location.pathname.endsWith('/newlca/sub-category'),'check1')
    //             if (!verticalid) {
    //                 // setVerticalId(true);
    //             }
    //         }
    //         else if (location.pathname.endsWith('/newlca')) {
    //             sessionStorage.removeItem('selectedVerticalId');
    //             return;
    //         }
    //     }
    // }, [location.pathname, draftLca, verticalid]);

    useEffect(() => {
        return () => {
            if (location.pathname.endsWith('/newlca')) {
                sessionStorage.removeItem('selectedVerticalId');
            }
        };
    }, []);

    return (
        <div>
            <Space h="xs" />
            <Title order={3}>Compute LCA</Title>
            <Space h="lg" />
            <VerticalsLca setid={handleVerticalSelect} />
            {location.pathname.endsWith('/newlca/sub-category') && (
                <CategoryType verticalid={verticalid} />
            )}
        </div>
    );
};

export default memo(NewLca);